import React, { useState } from "react";
import { snakeToTitleCase, toTitleCase } from "services/employer.service";
import { Job } from "services/types";
import DateLabel from "./date-label.component";
import PortalModal from "./portal-modal.component";

interface JobCardProps {
  job: Job
}

const JobCard: React.FC<JobCardProps> = ({ job }) => {
  const [selectedJob, setSelectedJob] = useState<Job>();
  const [show, setShow] = useState<boolean>(false);

  return (
    <>
      <div className="col-lg-4 col-md-6" key={job.ref_id}>
        <div className="job-card">
          <div className="job-header">
            <i className="bi bi-gear-wide-connected"></i>
            <h4>{job.job_type.name}, {toTitleCase(job.rank.name)}</h4>
          </div>
          <p><i className="bi bi-building"></i> {job.company_name}</p>
          <p><i className="bi bi-briefcase"></i> Experience: {job.exp[0]} - {job.exp[1]} year(s)</p>
          <p><i className="bi bi-calendar"></i> Posted: <DateLabel created_at={job.created_at} /></p>
          <div className="d-flex justify-content-between">
            <button
              type="button"
              className="btn btn-indigo"
              onClick={() => {
                setSelectedJob(job);
                setShow(true);
              }}
            >
              View Detail
            </button>
            <a
              href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=apply-job&job_ref_id=${job.ref_id}`}
              className="btn btn-indigo"
            >
              Apply Now
            </a>
          </div>
        </div>
      </div>
      <PortalModal show={show} onClose={() => setShow(false)} title="Job Details" >
        <dl className="row">
          <dt className="col-sm-3">Company</dt>
          <dd className="col-sm-9">{selectedJob?.company_name}</dd>
          <dt className="col-sm-3">Requested By</dt>
          <dd className="col-sm-9">{selectedJob?.requested_by}</dd>
          <dt className="col-sm-3">Contact No</dt>
          <dd className="col-sm-9">{selectedJob?.isd_code} - {selectedJob?.contact_no}</dd>

          {job.nationalities && job.nationalities.length > 0 && <>
            <dt className="col-sm-3">Nationalities</dt>
            <dd className="col-sm-9">
              {selectedJob?.nationalities.map((nationality: string, index: number) => (
                <span
                  key={index}
                  className="badge rounded-pill bg-primary me-2"
                >
                  {nationality}
                </span>
              ))}
            </dd>
          </>}

          <dt className="col-sm-3">Age</dt>
          <dd className="col-sm-9">{selectedJob?.age[0]} - {selectedJob?.age[1]} year(s)</dd>

          <dt className="col-sm-3">Experience</dt>
          <dd className="col-sm-9">{selectedJob?.exp[0]} - {selectedJob?.exp[1]} year(s)</dd>

          {selectedJob?.day_rate && <>
            <dt className="col-sm-3">Day Rate</dt>
            <dd className="col-sm-9">$ {selectedJob?.day_rate}</dd>
          </>}

          {selectedJob?.rotation && <>
            <dt className="col-sm-3">Rotation</dt>
            <dd className="col-sm-9">{selectedJob?.rotation} Day(s)</dd>
          </>}

          {selectedJob?.contract_type && <>
            <dt className="col-sm-3">Contract Type</dt>
            <dd className="col-sm-9">{snakeToTitleCase(selectedJob?.contract_type)}</dd>
          </>}
        </dl>
      </PortalModal>
    </>
  )
}

export default JobCard;
